module.exports = __webpack_public_path__ + "static/albumCover--wibe-of-life-6438ce155830151bee96dff68cfa221f.jpg";